import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Register from './components/Register';
import Login from './components/Login';
import Home from './components/Home';
import Logout from './components/Logout';
import UpdateUser from './components/UpdateUser';
import Header from './components/Header';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import AddProduct from './components/AddProduct';
import ProductList from './components/ProductList';
import ProductDetails from './components/ProductDetails';
import CartPage from './components/CartPage';
import AddressSelection from './components/AddressSelection';
import OrderSelection from './components/OrderSelection';
import OrderList from './components/OrderList';
import OrderTracking from './components/OderTracking';
import ProductSearch from './components/ProductSearch';
import WriteReview from './components/WriteReview';
import OtpVerification from './components/OtpVerification';
import ResetPassword from './components/ResetPassword';
import RazorpayPayment from './components/RazorpayPayment';


const App = () => {
  return (

    <div className="app-container">
      <Router>
        <Header />
        
        {/* Main content wrapped in app-main to ensure footer stays at bottom */}
        <div className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/add-product" element={<AddProduct />} />
            <Route path="/product-list" element={<ProductList />} />
            <Route path="/product/:id" element={<ProductDetails />} />
            <Route path="/login" element={<Login />} />
            <Route path="/otp-verification" element={<OtpVerification />} />
            <Route path="/update" element={<UpdateUser />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/orderSelection/:addressId" element={<OrderSelection />} />
            <Route path="/addressSelection" element={<AddressSelection />} />
            <Route path="/orderList" element={<OrderList />} />
            <Route path="/search" element={<ProductSearch />} />
            <Route path="/write-review/:id" element={<WriteReview />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/rasorpay" element={<RazorpayPayment />} />
            <Route path="/track-order/:orderId" element={<OrderTracking />} />
            {/* <Route path="/logout" element={<Logout />} /> */}
          </Routes>
        </div>
        {/* <ProductList /> */}
        {/* Footer will be positioned at the bottom of the page if content is short */}
        <Footer />
      </Router>
    </div>
  );
};

export default App;

// import React from 'react';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <h1>Welcome to My React App 🚀</h1>
//       <p>Start building your awesome project!</p>
//     </div>
//   );
// }

// export default App;

